import { useCallback } from "react";

import { useAppSelector } from "src/redux/hooks/redux";
import { selectCurrentCompany } from "src/redux/features/user/selectors/userState.selectors";

import { Contact } from "../_types/internalContacts.types";
import { ContactPersonStatus } from "../_types/workforcePresence.types";
import { getAgentStatusForContact } from "./useAgentStatusQuery";
import { useAgentStatusQuery } from "./useAgentStatusQuery";
import {
  getContactPresenceStatus,
  useWorkforcePresence,
} from "./useWorkforcePresence";

export const useContactPersonStatus = (enabled = true) => {
  const companyId = useAppSelector(selectCurrentCompany)?.id;
  const { presenceByWorkforceUid, presenceByUserUid } = useWorkforcePresence(enabled);
  const { data: agentStatusData } = useAgentStatusQuery(enabled ? companyId : null);

  const resolvePersonStatus = useCallback(
    (contact: Contact): ContactPersonStatus | null => {
      if (contact.type === "workforce") {
        return (
          getContactPresenceStatus(
            contact,
            presenceByWorkforceUid,
            presenceByUserUid,
          ) ?? "offline"
        );
      }

      if (contact.type === "organizationCoworker") {
        const workforceStatus = getContactPresenceStatus(
          contact,
          presenceByWorkforceUid,
          presenceByUserUid,
        );

        if (workforceStatus) {
          return workforceStatus;
        }

        return getAgentStatusForContact(agentStatusData?.agents ?? [], contact);
      }

      return null;
    },
    [agentStatusData?.agents, presenceByUserUid, presenceByWorkforceUid],
  );

  return { resolvePersonStatus };
};
